import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import { ChangeEvent, createElement, FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Language, { AVAILABLE_LANGUAGES } from '../../entity/Language';
import Select, { SelectItem } from '../component/compound/Select';
import LanguageComponent from '../component/primitive/Language';
import { SPACING_HUGE, SPACING_REGULAR, SPACING_UNIT } from '../constant/spacing';

type Props = {
  language: Language;
  onChangeLanguage: (e: ChangeEvent<HTMLElement>, language: Language) => void;
  onMount: () => void;
  onUnmount: () => void;
  className?: string;
};

const ConfigurationPage: FC<Props> = ({ language, onChangeLanguage, onMount, onUnmount, className }) => {
  useEffect(() => {
    onMount();
    return () => {
      onUnmount();
    };
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root className={className}>
      <PageHeading variant="h4" color="primary" noWrap>
        <FormattedMessage id="configuration_page.page_heading" />
      </PageHeading>
      <Section>
        <SectionHeading variant="h5" color="textSecondary">
          <FormattedMessage id="configuration_page.account_settings" />
        </SectionHeading>

        <Language>
          <LanguageSelect
            label={<FormattedMessage id="configuration_page.language_heading" />}
            defaultValue={language}
            onChange={onChangeLanguage as any}
          >
            {AVAILABLE_LANGUAGES.map((language) => (
              <SelectItem value={language} key={language}>
                <LanguageComponent language={language} />
              </SelectItem>
            ))}
          </LanguageSelect>
        </Language>
      </Section>
    </Root>
  );
};

const Root = styled('div')({
  padding: `${SPACING_UNIT * 10}px calc((100% - 960px) / 2)`,
});

const Section = styled('section')({
  marginBottom: SPACING_HUGE * 2,
});

const PageHeading = styled(Typography)({ marginBottom: SPACING_UNIT * 5 });

const SectionHeading = styled(Typography)({ marginBottom: SPACING_UNIT * 3 });

const Language = styled(Paper)({
  padding: SPACING_REGULAR,
});

const LanguageSelect = styled(Select)({ width: 192 });

const PointBalance = styled(Typography)({
  fontSize: 18,
  fontWeight: 700,
});
PointBalance.defaultProps = { color: 'primary' };

export default ConfigurationPage;
